<template>

  <v-container style="" class="someclass" :class="$vuetify.breakpoint.smAndDown ? 'center-content-mobile' : 'center-content-desktop'">
    <img :style="$vuetify.breakpoint.smAndDown ? 'height: 150px;' : 'height: 160px;'" :class="$vuetify.breakpoint.smAndDown ? 'ml-3': 'ml-2'" src="../../src/assets/check_web_1920.png">
    <h1 style="color: #0089CB; font-size: 35px;" class="mt-6">Thank You!</h1>
    <div style="color: #202020; position:relative;" :style="$vuetify.breakpoint.smAndDown? 'left: -34px; font-size:15px;':'left:-64px; font-size: 18px;'">Your Submission Has Been Received</div>
    <v-btn id="back-to-trials" height="60" width="250" rounded color="#0089CB"
      class="white--text mt-8 ml-7" elevation="0"
      style="left: -62px; position:relative; height: 50px;
      text-transform: none; font-size: 16px; font-weight: bold"
      @click="$router.push('/trials')">Go to Trials
    </v-btn>
  </v-container>

</template>

<script>
export default {
  name: "ThankYouPage",
  props: {
    id: String
  }
}
</script>

<style scoped>
.someclass {}

.center-content-desktop {
  position: absolute;
  left: 48.4%;
  top: 46%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-6%, -32%);
}

.center-content-mobile {
  padding-left: 26%;
  padding-top: 46%;
  /*position: absolute;*/
  /*left: 48%;*/
  /*top: 60%;*/
  /*-webkit-transform: translate(-24%, -68%);*/
  /*transform: translate(-24%, -68%);*/
}
</style>